import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import {
  primaryButtonStyles,
  secondaryButtonStyles,
} from "../../../../Styles/Styles";
import { useNavigate } from "react-router-dom";

const AdLimitReachedModal = ({ open, adLimit }) => {
  const storedUser = localStorage.getItem("user");
  const isVerified = storedUser.isVerifiedbyID;
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/my-ads");
  };

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason !== "backdropClick" && reason !== "escapeKeyDown") {
          handleRedirect();
        }
      }}
      aria-labelledby="ad-limit-dialog"
      maxWidth="xs"
      fullWidth
    >
      <DialogTitle
        id="ad-limit-dialog"
        sx={{ fontFamily: "ClashGrotesk-Medium", letterSpacing: 1 }}
      >
        Ad Limit Reached
        <IconButton
          aria-label="close"
          onClick={handleRedirect}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Typography
          variant="body1"
          sx={{ fontFamily: "ClashGrotesk-Regular", letterSpacing: 1 }}
        >
          You have reached your limit of <strong>{adLimit}</strong> active ads.
          Users without verified identity can post up to 5 ads. Verify your
          identity to increase your limit to 10.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ mt: 1, mb: 1 }}>
        <Button
          size="small"
          variant="contained"
          sx={secondaryButtonStyles}
          onClick={handleRedirect}
        >
          Go Back
        </Button>
        {isVerified ? (
          <Button
            size="small"
            variant="contained"
            sx={primaryButtonStyles}
            onClick={() => navigate("/pricing")}
          >
            Upgrade
          </Button>
        ) : (
          <Button
            size="small"
            variant="contained"
            sx={primaryButtonStyles}
            onClick={() => navigate("/profile")}
          >
            Verify ID
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default AdLimitReachedModal;
